<template>
  <CstuModal
    id="add-topic-modal"
    :title="isEditing ? 'Edit Topic' : 'Add Topic'"
    content-class="w-[650px]"
    dialog-class="!max-w-[650px]"
    size="lg"
    hide-footer
    centered
    no-close-on-backdrop
    radius="xl"
    @shown="handleShown"
  >
    <!-- Modal Body -->
    <div>
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Title <span class="text-red-500">*</span>
            <i
              v-tooltip="'Each topic represents a key subject for your brand’s content.'"
              class="far fa-question-circle p-0 cursor-pointer text-primary-cs ml-2"
            ></i>
          </label>
          <TextInput
            :model-value="formData.name"
            input-class="text"
            type="text"
            placeholder="Enter title of the topic."
            full-width
            radius="lg"
            size="lg"
            @update:model-value="formData.name = $event"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Description <span class="text-red-500">*</span>
            <i
              v-tooltip="'A short explanation of the topic’s focus. You can edit it to refine the AI-generated posts.'"
              class="far fa-question-circle p-0 cursor-pointer text-primary-cs ml-2"
            ></i>
          </label>
          <Textarea
            :model-value="formData.description"
            required
            rows="4"
            placeholder="Add short description against your topic."
            full-width
            radius="lg"
            size="md"
            :max-length="1000"
            @update:model-value="formData.description = $event"
          />
          <div class="text-xs text-gray-700 mt-1 text-right">
            {{ formData.description.length }} / 1000 characters
          </div>
        </div>

        <div class="flex justify-end gap-3 mt-6">
          <Button
            variant="light"
            color="light"
            size="sm"
            @click="handleClose"
          >
            Cancel
          </Button>
          <Button
            size="sm"
            @click="handleSave"
          >
            {{ isEditing ? 'Update' : 'Save' }}
          </Button>
        </div>
      </div>
    </div>
  </CstuModal>
</template>

<script setup>
import { ref, inject } from 'vue'
import { Button, Textarea, TextInput } from '@contentstudio/ui'
import { useStore } from '@state/base'

const root = inject('root')
const { $cstuModal } = root
const { dispatch } = useStore()
const emit = defineEmits(['hide', 'save'])

const formData = ref({
  name: '',
  description: '',
})

const isEditing = ref(false)



const handleClose = () => {
  formData.value = {
    name: '',
    description: '',
  }
  isEditing.value = false
  $cstuModal.hide('add-topic-modal')
}

const handleSave = () => {
  // show toast if name or description is empty
  if (!formData.value.name ) {
   dispatch('toastNotification', {
      message: 'Please add the title of the topic',
      type: 'error',
    })
    return
  }
  if (!formData.value.description) {
    dispatch('toastNotification', {
      message: 'Please add the description of the topic',
      type: 'error',
    })
    return
  }
  emit('save', {
    name: formData.value.name,
    description: formData.value.description,
  })

  handleClose()
}

const show = (topic = null) => {
  if (topic) {
    formData.value = { ...topic }
    isEditing.value = true
  } else {
    formData.value = { name: '', description: '' }
    isEditing.value = false
  }
  $cstuModal.show('add-topic-modal')
}

// Expose methods for parent component
defineExpose({
  show,
})
</script>
